// extracted by mini-css-extract-plugin
export default {"wrapper":"DescriptionTitle_wrapper__TqDiV","text":"DescriptionTitle_text__VtIQi"};